// components/QueueTable.jsx
import React from 'react';
import { ageRanges, ageRangeLabels } from '../constants/queueConstants';
import '../StatisticaQueue.css';

const QueueTable = ({ data, loading }) => {
    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Завантаження даних...</p>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="no-data-message">
                Не має інформації в обраному періоді
            </div>
        );
    }

    return (
        <div className="table-container">
            <div className="table-header">
                <p className="reg-title">Черга до ЗДО</p>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">№</th>
                            <th scope='col'>Район</th>
                            <th scope='col'>ЗДО</th>
                            <th scope="col" colSpan={ageRanges.length}>Вікова категорія</th>
                        </tr>
                        <tr>
                            {[1, 2, 3].map(r => <th scope="col" key={r}></th>)}
                            {ageRanges.map(age => (
                                <th scope="col" key={age}>{ageRangeLabels[age]}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, i) => (
                            <tr key={i}>
                                <td>{item.number}</td>
                                <td>{item.district}</td>
                                <td>{item.kindergartenNumber}</td>
                                {ageRanges.map(age => (
                                    <td key={age}>{item[age] || 0}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QueueTable;